import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from './sensor';
import { Router } from '@angular/router';

export class LevelSensor extends Sensor {
  public pressureChart: any;
  public waterChart: any;

  private pressSensor:    any[][];
  private waterSensor:    any[][];
  private waterPercentLast: (number | null)[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.pressureChart     = null;
    this.waterChart        = null;
    this.pressSensor       = [[], [], []];
    this.waterSensor       = [[], [], []];
    this.waterPercentLast  = [null, null, null];
  }

  public hasPressSensor(pos: number): boolean {
    return this.pressSensor[pos - 1].length > 0;
  }

  public getPressSensor(pos: number): any {
    const arr = this.pressSensor[pos - 1];
    return arr[arr.length - 1]?.[1] ?? null;
  }

  public hasWaterSensor(pos: number): boolean {
    return this.waterSensor[pos - 1].length > 0;
  }

  public getWaterSensor(pos: number): any {
    const arr = this.waterSensor[pos - 1];
    return arr[arr.length - 1]?.[1] ?? null;
  }

  public getWaterPercent(pos: number): number | null {
    return this.waterPercentLast[pos - 1];
  }

  public getWaterPercentBarValue(pos: number): number {
    const percent = this.getWaterPercent(pos);
    if (percent == null || !Number.isFinite(percent)) return 0;
    return Math.max(0, Math.min(100, percent));
  }

  public prepareData(): void {
    for (const element of this.data) {
      const date = new Date(element.date);
      const utc  = GraphUtils.getDateUtc(date);
      const pos  = element.position;

      this.pressSensor[pos].push([utc, element.preassure]);

      if (element.water != null) {
        this.waterSensor[pos].push([utc, element.water]);
        if (element.waterPercent != null) {
          this.waterPercentLast[pos] = element.waterPercent;
        }
      }
    }
  }

  public setCharts(): void {
    this.pressureChart = this.getConfigChar(
      'level',
      this.getChartSeries('Nivel', this.pressSensor),
      this.getRanges('9_preassure'),
      this.getLimits('9_preassure'),
    );

    const hasWater = this.waterSensor.some(s => s.length > 0);
    if (hasWater) {
      this.waterChart = this.getConfigChar(
        'level-water',
        this.getChartSeries('Volumen', this.waterSensor),
      );
    }
  }

  public static getVariables(): any[] {
    return [
      { title: 'Nivel de agua', value: '9_preassure' },
    ];
  }
}
